<div [formGroup]="frmGroup" fxFlex [hidden]="this.frmGroup.get(this.configData.name)['hidden']">
  <!-- <div>{{configData.label}}</div> -->
  <div [formArrayName]="configData.name" fxFlex class="mat-elevation-z0">
    <div *ngIf="allowedLine">
      <div *ngIf="isScrollPagination; else regularRowContainer">
        <cdk-virtual-scroll-viewport id="virtual-scroll-wrapper" [itemSize]="itemSize" class="virtual-scroll" (scroll)="onScroll()" (scrolledIndexChange)="onVirtualScrollItemLoaded()">
          <div #virtualRow *cdkVirtualFor="let row of getFormTableControls(); let rowIndex = index; templateCacheSize: 0" class="row mat-row smalldevice" [ngClass]="{odd: rowIndex % 2 === 2,'padding' : rowIndex, 'remove-footer-line': (frmGroup.get(configData.name)['controls']['canAddItem'] === false || configData['removeFooterLine'])}" style="margin: 0px">
            <!-- <div>1 {{ row?.value?.poLineItem }}</div> -->
            <div class="rows-container" [formGroupName]="rowIndex">
                <ng-container *ngTemplateOutlet="testTemplate; context: { rowControl: row, rowIndex: rowIndex }"></ng-container>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
      <ng-template #regularRowContainer>
        <div *ngFor="let row of getFormTableControls(); let rowIndex = index" class="row mat-row smalldevice padding" [ngClass]="{odd: rowIndex % 2 === 2, 'remove-footer-line': (frmGroup.get(configData.name)['controls']['canAddItem'] === false || configData['removeFooterLine'])}" style="margin: 0px">
            <div class="rows-container" [formGroupName]="rowIndex">
                <ng-container *ngTemplateOutlet="testTemplate; context: { rowControl: row, rowIndex: rowIndex }"></ng-container>
            </div>
        </div>
      </ng-template>
    </div>
    <div *ngIf="getFormTableControls().length === 0" class="row mat-footer-row">
      <div class="col">No {{ configData.label }} records added</div>
    </div>
    <!-- <div *ngIf="frmGroup.get(configData.name)['controls']['canAddItem'] === true" class="row mat-header-row" style="border-bottom: 0px;" [hidden]="frmGroup.status == 'DISABLED'"> -->
    <div *ngIf="!isFormGroupDisabled && frmGroup.get(configData.name)['controls']['canAddItem'] === true" class="row mat-header-row" style="border-bottom: 0px;" [hidden]="frmGroup.get(configData.name).status === 'DISABLED'">
      <div class="col mat-header-cell" style="font-size: 14px">
        <a href="#" (click)="addItem($event)">
          <img _ngcontent-dfi-c33="" src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1140,24,24))"/>
          <span class="add-label" (click)="addPoLine()">
            {{ enum.Add_Label | translate }} {{ configData.label | translate }}
          </span>
        </a>
      </div>
    </div>
    <!-- <div class="form-field-error"
            [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="error-icon">
                <img class="dhl-input-error-icon"
                    src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>
            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                <span *ngIf="frmGroup.get(configData.name).errors.required">Required</span>
                <span *ngIf="frmGroup.get(configData.name).errors.totalShipCount">{{noItemFoundError}}</span>
            </span>
        </div> -->
    </div>
    <ng-template #testTemplate let-rowControl="rowControl" let-rowIndex="rowIndex">
        <div class="row small-screen-row" *ngIf="isHandset$ | async">
            <div *ngIf="configData.lineNumber" class="lineLabel small-label">
                {{ rowIndex + 1 }}.
            </div>
            <div class="remove-label small-delete-icon">
                <a [hidden]="frmGroup.get(configData.name)['controls']['deleteButton'] === false || frmGroup.get(configData.name).status === 'DISABLED' || isFormGroupDisabled || configData.deleteButton === false">
                    <img src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))" (click)="deleteItem($event, rowIndex)" />
                </a>
            </div>
        </div>

        <div *ngIf="configData.lineNumber && !(isHandset$ | async)" class="lineLabel" fxFlex="0 0 30px">
          {{ rowIndex + 1 }}.
        </div>

        <div fxFlex="calc(100%-85px)">
            <div class="row" fxFlex="calc(100%-85px)">
                <div *ngFor="let control of configData.controls; let crlIdx =index;" [ngClass]="getColsClass(control.cols, control)" [class.hide]="control?.colsHidden && (rowControl.get(control.name)['hidden'] || (control?.UoMkey && uomData !== control?.UoMkey))">
                    <div *ngIf="selfServiceConfig" class="col mat-header-cell" style="font-size: 14px">
                        <span (click)="removeFields($event,control,rowIndex,crlIdx)">
                            <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))" />
                        </span>
                        <span (click)="editFieldConfig('false','updateField',control)">
                            <img src="../../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,5025,24,24))" />
                        </span>
                    </div>
                    <app-form-field [ngClass]="{'add-padding': frmGroup.controls[configData.name].errors}" [configData]="getControl(control)" [frmGroup]="rowControl"></app-form-field>
                </div>

                <span *ngIf="selfServiceConfig" (click)="editFieldConfig('false','addField','')">
                    <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1140,24,24))" />
                    <span class="add-label">Add New Field</span>
                </span>

                <div fxFlex="0 0 55px" class="d-block d-xl-none remove-label" *ngIf="!(isHandset$ | async)">
                    <a [hidden]="frmGroup.get(configData.name)['controls']['deleteButton'] === false || frmGroup.get(configData.name).status === 'DISABLED' || isFormGroupDisabled || configData.deleteButton === false">
                        <img src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))" (click)="deleteItem($event, rowIndex)" />
                    </a>
                </div>
            </div>
          <div class="delete-copy-container">
            <div class="d-none d-xl-block remove-label"
            *ngIf="frmGroup.get(configData.name)['controls']['deleteButton'] === true">
            <a
                [hidden]="frmGroup.get(configData.name)['controls']['deleteButton'] === false || frmGroup.get(configData.name).status === 'DISABLED' || isFormGroupDisabled || configData.deleteButton === false">
                <img src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))"
                  (click)="deleteItem($event,rowIndex)" />
              </a>
            </div>
            <div *ngIf="configData?.copyDataEnable" class="d-none d-xl-block copy-label">
              <a
                [hidden]="frmGroup.get(configData.name)['controls']['copyButton'] === false || frmGroup.get(configData.name).status === 'DISABLED' || isFormGroupDisabled">
                <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2630,24,24))"
                  (click)="copyItem($event,rowIndex)" />
              </a>
            </div>
          </div>

            <div class="col col-md-1" *ngIf="configData.lineNumber" class="lineLabel">
              <!-- <img src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))"> -->
            </div>

            <!-- <div class="col " fxFlex="0 0 55px" fxFlexAlign="center">
                    <a href="#" fxFlex="center center" (click)="addItem($event)">
                        <img src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))">
                    </a>
                    <button [hidden]="frmGroup.get(configData.name)['controls']['deleteButton'] === false || frmGroup.get(configData.name).status == 'DISABLED'" type="button" mat-icon-button (click)="deleteItem($event,rowIndex)" matTooltip="Delete {{configData.label}}">
                        <mat-icon color="accent">delete</mat-icon>
                    </button>
                </div> -->
        </div>
    </ng-template>
</div>

<div *ngIf="editField" class="dhl-form-self-service">
  <div class="sidemenu-header">
      <span class="dhl-icon-compoenent-cancel-v2" (click)="editFieldConfig('cancel','','')"></span>
  </div>
  <app-form-comp *ngIf="templateData" (formStatus)="getFormStatus($event)"   (form)="getForm($event)" [configData]=templateData [orderDetails]="configData" [lableForConfig]="lableForConfig"></app-form-comp>
  <div class="sidemenu-header">
      <span class="dhl-icon-generic-form-field-v2" (click)="editFieldConfig('cancel','','')"></span>
  </div>
</div>